const columns = [
  {
    title: '序号',
    width: 53,
    dataIndex: 'index',
    customRender: ({ index }) => index + 1,
  },
  {
    // title: '来源SKU规格',
    dataIndex: 'sku_name',
    slots: { title: 'skuNameTitle', customRender: 'skuName' },
    align: 'left',
  },
  {
    dataIndex: 'originPrice',
    title: '来源价格',
    slots: { customRender: 'originPrice' },
    sorter: (a, b) => a.origin_price - b.origin_price,
  },
  {
    dataIndex: 'originStockNum',
    title: '来源库存',
    slots: { customRender: 'originStockNum' },
  },
]

export default {
  columns
}